/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksGet } from "../../funcs/webhooksGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetWebhookRequest$inboundSchema,
};

export const tool$webhooksGet: ToolDefinition<typeof args> = {
  name: "webhooks-get",
  description: `Get details of a specific webhook.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
